import { ViewChild } from '@angular/core'

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import { CellTemplateDirective, ColumnComponent, GridComponent, KENDO_GRID } from '@progress/kendo-angular-grid'
import { ClientServices } from '../../../@theme/services/clients.service'
/* import { NbCardModule } from '@nebular/theme'; */
import { CommonModule, CurrencyPipe, DatePipe, NgFor } from '@angular/common'
import { TextAreaDirective } from '@progress/kendo-angular-inputs'
@Component({
    selector: 'gd-clienttrans',
    templateUrl: './clienttransaction.component.html',
    styleUrls: ['./clienttransaction.component.scss'],
    imports: [
        CommonModule,
        KENDO_GRID,
        NgFor,
        TextAreaDirective,
        GridComponent,
        ColumnComponent,
        CellTemplateDirective,
        CurrencyPipe,
        DatePipe,
    ]
})
export class ClienttransComponent implements OnInit {
  public ClientListlisted: any
  @ViewChild(GridComponent, { static: true })
  public grid: GridComponent
  public view: any[] = []
  @Input()
  outputBlotterId: any; // Changed from number to any to handle string values
  
  // Add event emitter for dialog close
  @Output() closeRequested = new EventEmitter<void>();
  
  public chooserows: number
  public dataClientlist: any = []
  public dataComments: any[] = []
  
  set clientId(value: any) {
    this.outputBlotterId = value;
  }
  
  get allowrepid(): any {
    return this.outputBlotterId;
  }
  
  constructor(
    private cliservice: ClientServices,
    private fb: UntypedFormBuilder,
  ) {
    this.chooserows = 2
  }

  ngOnInit() {
    if (this.outputBlotterId) {
      this.loadBlotterData(this.outputBlotterId);
    }
  }
  
  loadBlotterData(b: any) {
    // Ensure we have a valid ID to query
    if (!b) {
      console.error('No blotter ID provided');
      return;
    }
    
    // Convert to number if it's a string
    const blotterId = typeof b === 'string' ? parseInt(b, 10) : b;
    
    const param = { blotId: blotterId };
    this.cliservice.getblotterlist(param).subscribe(
      (response: any[]) => {
        this.dataClientlist = response;
        this.loadBlotterCommentData(blotterId);
      },
      (error) => {
        console.error('Error loading blotter data:', error);
      }
    );
  }
  loadBlotterCommentData(b: any) {
    // Convert to number if it's a string
    const blotterId = typeof b === 'string' ? parseInt(b, 10) : b;
    
    const param = { blotId: blotterId };
    this.cliservice.getblotterCommentlist(param).subscribe(
      (response: any[]) => {
        if (response.length > 0) {
          this.dataComments = response;
          this.chooserows = 5;
        }
        this.loadAlertgrid(blotterId);
      },
      (error) => {
        console.error('Error loading comment data:', error);
        this.loadAlertgrid(blotterId);
      }
    );
  }

  loadAlertgrid(b: any) {
    // Convert to number if it's a string
    const blotterId = typeof b === 'string' ? parseInt(b, 10) : b;
    
    const param = { blotId: blotterId };
    this.cliservice.getAlertLoglist(param).subscribe(
      (response: any[]) => {
        if (response.length > 0) {
          this.view = response;
        }
      },
      (error) => {
        console.error('Error loading alert data:', error);
      }
    );
  }
  
  // Method to close the dialog from within the component
  closeDialog() {
    this.closeRequested.emit();
  }
  }

